import axios from 'axios';
import store from '@/store';
import i18n from "@/i18n";

const baseDomain: string = store.getters.service ? store.getters.service : '';

export default axios.create({baseURL: baseDomain, timeout: Number.parseInt(process.env.VUE_APP_AXIOS_TIMEOUT || "6500"), timeoutErrorMessage: i18n.tc("Error.Timeout")});

export const {CancelToken} = axios;
